import { useEffect, useState } from 'react';
import { loadTimings, pickRow } from './timings';

// The timing row for each of `urls` in language `lang` (see timingLangFor),
// lined up with `urls`: a row, or null while loading and when there is none.
// No language means no timings, and nothing is fetched.
export function useTimingRows(urls, lang) {
  const joined = (urls || []).map(u => u || '').join('\n');
  const [state, setState] = useState({ joined: '', lang: null, rows: [] });

  useEffect(() => {
    if (!lang || !joined.trim()) return;
    let cancelled = false;
    const list = joined.split('\n');
    loadTimings(list).then(byKey => {
      if (!cancelled) setState({ joined, lang, rows: list.map(u => pickRow(byKey, u, lang)) });
    });
    return () => { cancelled = true; };
  }, [joined, lang]);

  // Rows from an earlier set of urls never apply to the current one.
  const current = state.joined === joined && state.lang === lang;
  return current ? state.rows : (urls || []).map(() => null);
}

// Seeks `el` to `seconds` and plays. A recording that has not loaded yet
// (iOS loads nothing until asked) takes the seek once it knows its length.
export function playAt(el, seconds) {
  if (!el) return;
  const apply = () => { try { el.currentTime = seconds; } catch { /* not seekable yet */ } };
  apply();
  if (el.readyState < 1) el.addEventListener('loadedmetadata', apply, { once: true });
  const p = el.play();
  if (p && p.catch) p.catch(() => {});
}
